// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2Ykz9","modalFooterButton":"ModalNotes_modalFooterButton__Hk0v0"};